class WishlistShareButton extends HTMLElement {
  connectedCallback () {
    this.setupListeners()
  }

  setupListeners () {
    this.addEventListener('click', this.handleShare.bind(this))
  }

  async handleShare (e) {
    this.querySelector('button').textContent = this.dataset.textCreating

    const wishlistId = e.target.closest('[data-wishlist-id]').dataset.wishlistId
    const listPublic = await this.markListPublic(wishlistId)

    if (!listPublic) {
      this.querySelector('button').textContent = this.dataset.textDefault
      return
    }

    let shareUrl = await this.generateWishlistShareUrl(e)
    shareUrl = shareUrl.replace('swym-share-wishlist', 'wishlist')

    setTimeout(async () => {
      await navigator.clipboard.writeText(shareUrl).then(() => {
        this.querySelector('button').textContent = this.dataset.textCreated
        if (navigator.share) {
          navigator.share({
            url: shareUrl,
          })
        }
      })
    }, 100)
  }

  generateWishlistShareUrl (e) {
    const wishlistId = e.target.closest('[data-wishlist-id]').dataset.wishlistId

    return new Promise((resolve, reject) => {
      const onSuccess = (link, lid) => {
        resolve(link)
      }
      const onError = (error) => {
        console.error('Error while generating the link', error)
        this.querySelector('button').textContent = this.dataset.textDefault
        reject(error)
      }

      window._swat.generateSharedListURL(wishlistId, onSuccess, onError)
    })
  }

  markListPublic (wishlistId) {
    return new Promise((resolve) => {
      const onSuccess = function (wishlists) {
        // console.info('markListPublic() - Success', wishlists)

        resolve(true)
      }
      const onError = function (error) {
        console.error('markListPublic() - Error', error)
      }

      window._swat.markListPublic(
        wishlistId,
        onSuccess,
        onError,
      )
    })
  }
}

customElements.define('wishlist-share', WishlistShareButton)
